/**
 * Plugin: Messenger (Facebook Page DMs via Meta Graph API).
 * Implementa o ChannelPlugin contract.
 */

import React from 'react';
import { IconBrandMessenger } from '@tabler/icons-react';
import { CHANNEL_CATEGORIES } from '../../types';

import useStatus from './useStatus';
import Card from './Card';
import Detail from './Detail';
import ConnectFlow from './ConnectFlow';

const MessengerChannel = {
  id: 'messenger',
  name: 'Messenger',
  description: 'Mensagens da Página Facebook via Meta Graph API.',
  icon: IconBrandMessenger,
  color: '#0084FF',
  gradient: 'linear-gradient(135deg, #0084FF 0%, #0066CC 100%)',
  category: CHANNEL_CATEGORIES.MESSAGING,
  isAvailable: true,
  provider: 'messenger',
  conflictsWith: [],

  useStatus,

  renderCard: (agentId, context) => <Card agentId={agentId} context={context} />,
  renderDetail: (agentId, navigation, onAlertCTA) => (
    <Detail agentId={agentId} navigation={navigation} onAlertCTA={onAlertCTA} />
  ),
  renderConnectFlow: (agentId, onConnected, onCancel) => (
    <ConnectFlow agentId={agentId} onConnected={onConnected} onCancel={onCancel} />
  ),
};

export default MessengerChannel;
